const Material = () => import('@/views/main/promotion/material/Material.vue')
export default {
  path: '/main/promotion/material',
  name: 'Material',
  component: Material,
  children: []
}
